module.exports = "<div class=holding-dashboard-sidebar__section> <h3 class=\"heading-h4 h-gold-text\" ng-bind=\"'Current Progress'|translate\"> </h3> <h4 class=\"heading-h2 h-dark-text\" ng-bind=label|translate> </h4> <holding-flow-sidebar-progress-steps steps=steps></holding-flow-sidebar-progress-steps> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/flow/directives/flow-sidebar-progress-section/flow-sidebar-progress-section.html
// module id = 529
// module chunks = 0